import { PerformanceRiskAnalysis } from './analysis/performance-risk-analysis.model';
import { PeerAnalysis } from './analysis/peer-analysis.model';
import { ComponentsAnalysis } from './analysis/components-analysis.model';
import { FactorAnalysis } from './analysis/factor-analysis.model';
import { RobustnessAnalysis } from './analysis/robustness-analysis.model';
import { PositionKeepingAnalysis } from "./analysis/position-keeping-analysis.model";
import { MetricsAnalysis } from './analysis/metrics-analysis.model';
import { SimulationAnalysis } from './analysis/simulation-analysis.model';
import { Currency } from './currency.model';
import { MarketPositions } from './market-positions.model';
import { InvestmentZone } from './investment-zone.model';

export class CurrentPortfolio {
  public id: number;
  public name: string;
  public investment_zone: InvestmentZone;
  public currency: Currency;
  public market_position: MarketPositions;
  public asset_class: string;
  public ticker: string;
  public strategy_target: string;
  public nb_components: string;
  public components_names: string;
  public components_weights: string;
  public components_alpha: string;
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;
  public investment_date: Date;
  public last_update: Date;
  public completeness_names: string;
  public completeness_weights: string;
  public weighting: any;
  public distance: any;

  public parameters: any;
  public peer_analysis: PeerAnalysis;
  public performance_risk_analysis: PerformanceRiskAnalysis;
  public components_analysis: ComponentsAnalysis;
  public factor_analysis: FactorAnalysis;
  public robustness_analysis: RobustnessAnalysis;
  public metrics_analysis: MetricsAnalysis;
  public simulation_analysis: SimulationAnalysis;
  public position_keeping_analysis: PositionKeepingAnalysis;

  public peerAnalysis: PeerAnalysis;
  public performanceRiskAnalysis: PerformanceRiskAnalysis;
  public componentsAnalysis: ComponentsAnalysis;
  public factorAnalysis: FactorAnalysis;
  public robustnessAnalysis: RobustnessAnalysis;
  public metricsAnalysis: MetricsAnalysis;
  public simulationAnalysis: SimulationAnalysis;
  public positionKeepingAnalysis: PositionKeepingAnalysis;

  constructor(id: number) {
      this.id = id;
  }

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.name                      = data.name ? data.name : undefined;
    this.investment_zone           = data.investment_zone ? data.investment_zone : undefined;
    this.currency                  = data.currency ? data.currency : undefined;
    this.market_position           = data.market_position ? data.market_position : undefined;
    this.asset_class               = data.asset_class ? data.asset_class : undefined;
    this.ticker                    = data.ticker ? data.ticker : undefined;
    this.strategy_target           = data.strategy_target ? data.strategy_target : undefined;
    this.nb_components             = data.nb_components;
    this.components_names          = data.components_names ? data.components_names : undefined;
    this.components_weights        = data.components_weights ? data.components_weights : undefined;
    this.components_alpha          = data.components_alpha ? data.components_alpha : undefined;
    this.creation_date             = data.creation_date ? new Date(data.creation_date) : undefined;
    this.inception_date            = data.inception_date ? new Date(data.inception_date) : undefined;
    this.last_date                 = data.last_date ? new Date(data.last_date) : undefined;
    this.investment_date           = data.investment_date ? new Date(data.investment_date) : undefined;
    this.last_update               = data.last_update ? new Date(data.last_update) : undefined;
    this.completeness_names        = data.completeness_names ? data.completeness_names : undefined;
    this.completeness_weights      = data.completeness_weights ? data.completeness_weights : undefined;
    this.weighting                 = data.weighting ? data.weighting : undefined;
    this.distance                  = data.distance ? data.distance : undefined;

    this.parameters                = data.parameters ? data.parameters : undefined;
    this.peer_analysis             = data.peer_analysis ? data.peer_analysis : undefined;
    this.performance_risk_analysis = data.performance_risk_analysis ? data.performance_risk_analysis : undefined;
    this.components_analysis       = data.components_analysis ? data.components_analysis : undefined;
    this.factor_analysis           = data.factor_analysis ? data.factor_analysis : undefined;
    this.robustness_analysis       = data.robustness_analysis ? data.robustness_analysis : undefined;
    this.metrics_analysis          = data.metrics_analysis ? data.metrics_analysis : undefined;
    this.simulation_analysis       = data.simulation_analysis ? data.simulation_analysis : undefined;
    this.position_keeping_analysis = data.position_keeping_analysis ? data.position_keeping_analysis : undefined;

    this.peerAnalysis = new PeerAnalysis();
    this.performanceRiskAnalysis = new PerformanceRiskAnalysis();
    this.componentsAnalysis = new ComponentsAnalysis();
    this.factorAnalysis = new FactorAnalysis();
    this.robustnessAnalysis = new RobustnessAnalysis();
    this.metricsAnalysis  = new MetricsAnalysis();
    this.simulationAnalysis = new SimulationAnalysis();
    this.positionKeepingAnalysis = new PositionKeepingAnalysis();

    this.peerAnalysis.initFromData(this.peer_analysis);
    this.performanceRiskAnalysis.initFromData(this.performance_risk_analysis);
    this.componentsAnalysis.initFromData(this.components_analysis);
    this.factorAnalysis.initFromData(this.factor_analysis);
    this.robustnessAnalysis.initFromData(this.robustness_analysis);
    this.metricsAnalysis.initFromData(this. metrics_analysis);
    this.simulationAnalysis.initFromData(this.simulation_analysis);
    this.positionKeepingAnalysis.initFromData(this.position_keeping_analysis);
  }
}
